import React from 'react'
import { FieldRenderProps } from 'react-final-form'

import { OxfordLegacyProps } from '@cinch-labs/design-system/dist/src/global'
import { InlineRadioClassNameProps, InlineRadioField } from '@cinch-labs/design-system'
import showRealtimeError from '@cinch/oxd-components/error/src/show-realtime-error'

interface FieldInlineRadioProps extends FieldRenderProps, OxfordLegacyProps {
  classNames?: InlineRadioClassNameProps
  label?: string
  options?: Array<{ value: any; label: string; id: string }>
}

const FieldInlineRadio: React.FC<FieldInlineRadioProps> = ({
  classNames,
  input,
  label = '',
  meta,
  options = [],
  oxford = false,
}) => {
  return (
    <InlineRadioField
      {...input}
      label={label}
      options={options.map((option, index) => {
        option.id = `${input.name}-${index}`
        return option
      })}
      oxford={oxford}
      error={{ show: showRealtimeError(meta), message: meta.error || meta.submitError }}
      classNames={classNames}
    />
  )
}

export default FieldInlineRadio
